export const DRAWER_WIDTH = 280;
export const HEADER_HEIGHT = '64px';

export const styles = {
  desktopMenuButton: {
    color: 'text.primary',
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '1rem',
    minWidth: 'auto',
    padding: 0,
    marginLeft: '24px !important',
    '&:hover': {
      backgroundColor: 'transparent',
      boxShadow: 'none',
      textDecoration: 'underline',
      transform: 'none',
    },
  },
  mobileListItem: {
    borderRadius: 1,
    mb: 0.5,
    '&:hover': { bgcolor: 'action.hover' },
  },
  mobileSubItem: {
    borderRadius: 1,
    mb: 0.25,
    py: 0.5,
    pl: 2,
    '&:hover': { bgcolor: 'action.hover' },
    display: 'flex',
    flexDirection: 'row',
    gap: '4px',
  },
} as const;
